import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Button } from "semantic-ui-react";
import allAxiosCommonTA from "./../axiosComponent/allAxiosCommonTA";
import cogoToast from "cogo-toast";

const AllotFromVehicleAvailability = ({ ...props }) => {
    useEffect(() => {
    }, []);

    const onClick = (e) => {
        let allot_details = {
            "lr_no": null,
            "lr_date": null,
            "vehicle_availability_id": props.agGridReact.props.vehicleID
        };
        allAxiosCommonTA({
            url: "/bookings/indent/planning/allot", method: "post",
            Items: {
                allot_details,
                action_code: "ALLOT",
                booking_id: props.data.booking_id,
            }
        })
            .then((response) => {
                window.location.reload();
                cogoToast.success(response.data.message)
            })
            .catch((err) => {
                console.log("err", err);
                cogoToast.error("Error While Allocation.")
            });

    };

    return (
        <Button
            className="width-100cent"
            onClick={e => onClick(e)}
            primary
        >
            Allot
        </Button>
    )
}

export default AllotFromVehicleAvailability;
